import React, {useCallback, useEffect} from 'react';
import Alert from 'react-bootstrap/Alert';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {selectError, setError} from './errorSlice';
import AlertClose from '../../UI/AlertClose';
import {StyledBootstrapAlert} from '../../mixins';


const StyledAlert = styled(Alert)`
 ${StyledBootstrapAlert('error')};
 z-index: 2500;

`

const Error = () => {
    const error = useSelector(selectError);
    const dispatch = useDispatch();

    const clearError = useCallback(() => dispatch(setError({show: false, text: '', type: ''})), [dispatch])

    useEffect(() => {
        if (error.show) {
            setTimeout(clearError, 3000);
        }
    }, [error, clearError])

    return (
        <StyledAlert show={error.show} onClose={clearError} variant="danger">
            <AlertClose onClick={clearError}/>
            <p>{error.text}</p>
        </StyledAlert>
    )
};

export default Error;
